// Login Actions
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const SEND_TEMP_CREDENTIALS = 'SEND_TEMP_CREDENTIALS';
export const GET_CHALLENGE_QUESTION = 'GET_CHALLENGE_QUESTION';
export const SET_CHALLENGE_QUESTION = 'SET_CHALLENGE_QUESTION';
export const FETCH_CHALLENGE_QUESTIONS = 'FETCH_CHALLENGE_QUESTIONS';

export const GET_ACCOUNTS = 'GET_ACCOUNTS';
export const PREFERED_ACCOUNT_ID = 'PREFERED_ACCOUNT_ID';
export const SET_ACTIVE_ACCOUNT = 'SET_ACTIVE_ACCOUNT';
export const GET_USER_DETAILS = 'GET_USER_DETAILS';

export const GET_STUDIES = 'GET_STUDIES';
export const NO_ESSENTIALS_STUDIES = 'NO_ESSENTIALS_STUDIES';
export const UPDATE_MODULE_STUDY = 'UPDATE_MODULE_STUDY';
export const SET_TREND_STUDIES = 'SET_TREND_STUDIES';
export const CLEAR_TREND_STUDIES = 'CLEAR_TREND_STUDIES';
export const VALID_TREND_ROW_COL_BASES = 'VALID_TREND_ROW_COL_BASES';
export const SET_SC_STUDY = 'SET_SC_STUDY';
export const GET_SC_STUDY = 'GET_SC_STUDY';
export const NO_SC_STUDIES = 'NO_SC_STUDIES';
export const FILTER_STUDIES_BASED_ON_WEIGHT_TYPE =
  'FILTER_STUDIES_BASED_ON_WEIGHT_TYPE';

export const GET_DICTIONARY_TREE_LOAD = 'GET_DICTIONARY_TREE_LOAD';
export const GET_DICTIONARY_TARGET_LOAD = 'GET_DICTIONARY_TARGET_LOAD';
export const UPDATE_DICTIONARY_TREE_LOAD = 'UPDATE_DICTIONARY_TREE_LOAD';
export const SEARCH_DICTIONARY_TREE_LOAD = 'SEARCH_DICTIONARY_TREE_LOAD';
export const SET_DICTIONARY_USE_QUESTIONS = 'SET_DICTIONARY_USE_QUESTIONS';
export const GET_DICTIONARY_TARGET_LOAD_FROM_SEARCH =
  'GET_DICTIONARY_TARGET_LOAD_FROM_SEARCH';
export const RESET_DICTIONARY_TARGET = 'RESET_DICTIONARY_TARGET';
export const SET_DATAPOINTS_ALREADY_ADDED = 'SET_DATAPOINTS_ALREADY_ADDED';

// Geographies Tab
export const GET_INITIAL_GEOGRAPHY_TREE = 'GET_INITIAL_GEOGRAPHY_TREE';
export const GET_GEOGRAPHY_TREE_LOAD = 'GET_GEOGRAPHY_TREE_LOAD';
export const UPDATE_GEOGRAPHY_TREE_LOAD = 'UPDATE_GEOGRAPHY_TREE_LOAD';
export const SEARCH_GEOGRAPHY_TREE_LOAD = 'SEARCH_GEOGRAPHY_TREE_LOAD';
export const GET_GEOGRAPHY_SMART_SEARCH = 'GET_GEOGRAPHY_SMART_SEARCH';
export const CLEAR_GEOGRAPHY_SMART_SEARCH = 'CLEAR_GEOGRAPHY_SMART_SEARCH';

export const GET_DEFINITION_TREE_LOAD = 'GET_DEFINITION_TREE_LOAD';
export const GET_DEFINITION_TREE_LIST_LOAD = 'GET_DEFINITION_TREE_LIST_LOAD';
export const GET_DEFINITION_TARGET_LOAD = 'GET_DEFINITION_TARGET_LOAD';
export const UPDATE_DEFINITION = 'UPDATE_DEFINITION';
export const GET_SHARED_DEFINITION_LIST = 'GET_SHARED_DEFINITION_LIST';
export const DELETE_DEFINITION_TARGET = 'DELETE_DEFINITION_TARGET';

export const REMOVE_CROSSTAB_DATA = 'REMOVE_CROSSTAB_DATA';
export const CLEAR_CROSSTAB_SAMPLE_WEIGHTED = 'CLEAR_CROSSTAB_SAMPLE_WEIGHTED';
export const UPDATE_CROSSTAB_SAMPLE_WEIGHTED =
  'UPDATE_CROSSTAB_SAMPLE_WEIGHTED';
export const GET_CROSSTAB_SAMPLE_WEIGHTED = 'GET_CROSSTAB_SAMPLE_WEIGHTED';
export const GET_AUTOCODE_SAMPLE_WEIGHTED =
  'GET_AUTOCODE_CROSSTAB_SAMPLE_WEIGHTED';
export const SELECT_CROSSTAB_GRID = 'SELECT_CROSSTAB_GRID';
export const DELETE_CROSSTAB_GRID = 'DELETE_CROSSTAB_GRID';
export const UPDATE_CROSSTAB_GRID = 'UPDATE_CROSSTAB_GRID';
export const SHOW_SAVED_CROSSTABS = 'SHOW_SAVED_CROSSTABS';
export const SHOW_VALIDATE_RESPONSE = 'SHOW_VALIDATE_RESPONSE';
export const SHOW_NEWSPC_VALIDATE_RESPONSE = 'SHOW_NEWSPC_VALIDATE_RESPONSE';
export const LOAD_SAVED_CROSSTAB = 'LOAD_SAVED_CROSSTAB';
export const LOAD_NEWSPC_SAVED_CROSSTAB = 'LOAD_NEWSPC_SAVED_CROSSTAB';
export const UPDATE_NEWSPC_SAVED_CROSSTAB_DATA =
  'UPDATE_NEWSPC_SAVED_CROSSTAB_DATA';
export const SET_SELECTED_LABEL_AC = 'SET_SELECTED_LABEL_AC';
export const DELETE_SAVED_CROSSTAB = 'DELETE_SAVED_CROSSTAB';
export const UPDATE_SAVED_CROSSTAB_INFO = 'UPDATE_SAVED_CROSSTAB_INFO';
export const SHOW_CROSSTAB_GRID = 'SHOW_CROSSTAB_GRID';
export const EXPORT_CROSSTAB = 'EXPORT_CROSSTAB';
export const FETCH_CROSSTAB_KPI = 'FETCH_CROSSTAB_KPI';
export const REMOVE_CROSSTAB_KPI = 'REMOVE_CROSSTAB_KPI';
export const SET_SELECTED_BASE = 'SET_SELECTED_BASE';
export const SET_ACTIVE_CROSSTAB_TABLE = 'SET_ACTIVE_CROSSTAB_TABLE';
export const MANAGE_USER_STATE_POPUP = 'MANAGE_USER_STATE_POPUP';
export const IS_USER_STATE_POPUP_SHOWN = 'IS_USER_STATE_POPUP_SHOWN';
export const IS_LOGOUT = 'IS_LOGOUT';
export const ADD_DD_NHCS_CROSSTAB_REPORT = 'ADD_DD_NHCS_CROSSTAB_REPORT';
export const UPDATE_TOGGLE_LABEL_FLAG = 'UPDATE_TOGGLE_LABEL_FLAG';
export const UPDATE_COLUMN_CT_SORT = 'UPDATE_COLUMN_CT_SORT';

export const CLEAR_REPORTS_SAMPLE_WEIGHTED = 'CLEAR_REPORTS_SAMPLE_WEIGHTED';
export const UPDATE_REPORTS_SAMPLE_WEIGHTED = 'UPDATE_REPORTS_SAMPLE_WEIGHTED';
export const GET_REPORTS_SAMPLE_WEIGHTED = 'GET_REPORTS_SAMPLE_WEIGHTED';
export const CLEAR_REPORT = 'CLEAR_REPORT';
export const SELECT_REPORT = 'SELECT_REPORT';
export const CLEAR_ALL_REPORT = 'CLEAR_ALL_REPORT';
export const RUN_REPORT = 'RUN_REPORT';
export const EXPORT_REPORT = 'EXPORT_REPORT';
export const ADD_QUICKREPORT_PARAMS_REDUX = 'ADD_QUICKREPORT_PARAMS_REDUX';
export const UPDATE_MAP_SETTINGS = 'UPDATE_MAP_SETTINGS';

export const GET_DATAHAUL_REPORTS = 'GET_DATAHAUL_REPORTS';
export const UPDATE_DATAHAUL_REPORTS = 'UPDATE_DATAHAUL_REPORTS';
export const RENAME_DATAHAUL_REPORT = 'RENAME_DATAHAUL_REPORT';
export const DELETE_DATAHAUL_REPORT = 'DELETE_DATAHAUL_REPORT';
export const DATAHAUL_POLLING_PROGRESS = 'DATAHAUL_POLLING_PROGRESS';
export const CLEAR_DATAHAUL_POLLING_TIMER = 'CLEAR_DATAHAUL_POLLING_TIMER';

export const ADD_NEW_STORYBOARD = 'ADD_NEW_STORYBOARD';
export const GET_STORYBOARD_SAMPLE_WEIGHTED = 'GET_STORYBOARD_SAMPLE_WEIGHTED';
export const UPDATE_STORYBOARD_SAMPLE_WEIGHTED =
  'UPDATE_STORYBOARD_SAMPLE_WEIGHTED';
export const SHOW_STORYBOARD_GRID = 'SHOW_STORYBOARD_GRID';
export const FETCH_STORYBOARD_KPI = 'FETCH_STORYBOARD_KPI';
export const REMOVE_STORYBOARD_DATA = 'REMOVE_STORYBOARD_DATA';
export const CLEAR_STORYBOARD_SAMPLE_WEIGHTED =
  'CLEAR_STORYBOARD_SAMPLE_WEIGHTED';
export const SELECT_STORYBOARD_GRID = 'SELECT_STORYBOARD_GRID';
export const DELETE_STORYBOARD_GRID = 'DELETE_STORYBOARD_GRID';
export const UPDATE_STORYBOARD_GRID = 'UPDATE_STORYBOARD_GRID';
export const LOAD_SAVED_STORYBOARD = 'LOAD_SAVED_STORYBOARD';
export const EXPORT_STORYBOARD = 'EXPORT_STORYBOARD';
export const DELETE_SAVED_STORYBOARD = 'DELETE_SAVED_STORYBOARD';
export const UPDATE_SAVED_STORYBOARD_INFO = 'UPDATE_SAVED_STORYBOARD_INFO';
export const SHOW_SAVED_STORYBOARDS = 'SHOW_SAVED_STORYBOARDS';
export const UPDATE_CROSSTAB_ID = 'UPDATE_CROSSTAB_ID';
export const UPDATE_CROSSTAB_TITLE_LIST = 'UPDATE_CROSSTAB_TITLE_LIST';
export const UPDATE_RENAMED_GRID_INDEX = 'UPDATE_RENAMED_GRID_INDEX';

// Insight360
export const SHOW_BRAND_INSIGHT360_PERSONAS_DEMOGRAPHICS =
  'SHOW_BRAND_INSIGHT360_PERSONAS_DEMOGRAPHICS';
export const SHOW_BRAND_INSIGHT360_PERSONAS_ATTITUDES =
  'SHOW_BRAND_INSIGHT360_PERSONAS_ATTITUDES';
export const SHOW_BRAND_INSIGHT360_PERSONAS_BRANDS =
  'SHOW_BRAND_INSIGHT360_PERSONAS_BRANDS';
export const SHOW_MEDIA_INSIGHT360_PERSONAS_MEDIA =
  'SHOW_MEDIA_INSIGHT360_PERSONAS_MEDIA';
export const UPDATE_BRAND_INSIGHT360_MEDIA = 'UPDATE_BRAND_INSIGHT360_MEDIA';
export const UPDATE_BRAND_INSIGHT360_HEADERINFO =
  'UPDATE_BRAND_INSIGHT360_HEADERINFO';
export const GET_360_STUDY = 'GET_360_STUDY';
export const GET_360_DEMOGRAPHICS_FILTER_OPTIONS =
  'GET_360_DEMOGRAPHICS_FILTER_OPTIONS';
export const SAVE_BRAND_INSIGHT360_HEADER_INFO =
  'SAVE_BRAND_INSIGHT360_HEADER_INFO';
export const UPDATE_BRAND_INSIGHT360_BRANDS = 'UPDATE_BRAND_INSIGHT360_BRANDS';
export const SAVE_BRAND_INSIGHT360_PERSONA_FILTER =
  'SAVE_BRAND_INSIGHT360_PERSONA_FILTER';
export const UPDATE_BRAND_INSIGHT360_DEMOGRAPHICS_PERSONAS =
  'UPDATE_BRAND_INSIGHT360_DEMOGRAPHICS_PERSONAS';
export const RESET_ALL_INSIGHT360 = 'RESET_ALL_INSIGHT360';
export const REMOVE_DEMOGRAPHIC = 'REMOVE_DEMOGRAPHIC';
export const UPDATE_BRAND_INSIGHT360_ATTITUDES_PERSONAS =
  'UPDATE_BRAND_INSIGHT360_ATTITUDES_PERSONAS';
export const UPDATE_ATTITUDE_INSIGHT_AGREE_CHOICE =
  'UPDATE_ATTITUDE_INSIGHT_AGREE_CHOICE';
export const SHOW_INSIGHT360_PERSONAS_PROFILES =
  'SHOW_INSIGHT360_PERSONAS_PROFILES';
export const UPDATE_BRAND_INSIGHT360_PROFILES =
  'UPDATE_BRAND_INSIGHT360_PROFILES';
export const GET_360_REPORTS_DICTIONARY_TREE_LOAD =
  'GET_360_REPORTS_DICTIONARY_TREE_LOAD';
export const SEARCH_360_REPORTS_DICTIONARY_TREE_LOAD =
  'SEARCH_360_REPORTS_DICTIONARY_TREE_LOAD';
export const SAVE_BRAND_INSIGHT360_BASE_INFO =
  'SAVE_BRAND_INSIGHT360_BASE_INFO';
export const SHOW_INSIGHT360_PERSONAS_REPORTVIEW =
  'SHOW_INSIGHT360_PERSONAS_REPORTVIEW';
export const SAVE_360_DICTIONARY_SELECTED_CATEGORY =
  'SAVE_360_DICTIONARY_SELECTED_CATEGORY';
export const GET_360_REPORTS_DEFINITION_TREE_LOAD =
  'GET_360_REPORTS_DEFINITION_TREE_LOAD';
export const GET_360_REPORTS_DEFINITION_TARGET_LOAD =
  'GET_360_REPORTS_DEFINITION_TARGET_LOAD';
export const UPDATE_PERSONA_FIXED_HEADER_CHOICE =
  'UPDATE_PERSONA_FIXED_HEADER_CHOICE';
export const INVALID_PERSONA_SELECTED = 'INVALID_PERSONA_SELECTED';
export const PERSONA_CREATOR_360_CLUSTER_SEGMENTS =
  'PERSONA_CREATOR_360_CLUSTER_SEGMENTS';
export const SAVE_PERSONA_CREATOR_HEADER_INFO =
  'SAVE_PERSONA_CREATOR_HEADER_INFO';
export const REMOVE_PERSONA_CREATOR = 'REMOVE_PERSONA_CREATOR';
export const UPDATE_CREATOR_ATTITUDE_INSIGHT_AGREE_CHOICE =
  'UPDATE_CREATOR_ATTITUDE_INSIGHT_AGREE_CHOICE';
export const PERSONA_CREATOR_360_MULTIPLE_CLUSTER_SEGMENTS =
  'PERSONA_CREATOR_360_MULTIPLE_CLUSTER_SEGMENTS';
export const SET_IS_PERSONA_CREATOR_SEGMENT_SCREEN =
  'SET_IS_PERSONA_CREATOR_SEGMENT_SCREEN';
export const UPDATE_PERSONA_CREATOR_SEGMENTS =
  'UPDATE_PERSONA_CREATOR_SEGMENTS';
export const SAVE_CREATOR_ATTITUDE_INSIGHT_DATA =
  'SAVE_CREATOR_ATTITUDE_INSIGHT_DATA';
export const UPDATE_PERSONA_CREATOR_DEFINITION_NAME =
  'UPDATE_PERSONA_CREATOR_DEFINITION_NAME';
export const UPDATE_MODIFY_SEGMENT_NAME = 'UPDATE_MODIFY_SEGMENT_NAME';
export const SAVE_BRAND_INSIGHT360_VERTICAL_PERCENT =
  'SAVE_BRAND_INSIGHT360_VERTICAL_PERCENT';

export const SET_PERSONA_CREATOR_POPUP_DISPLAY =
  'SET_PERSONA_CREATOR_POPUP_DISPLAY';
export const SET_360_REPORTER_SORT_INFO = 'SET_360_REPORTER_SORT_INFO';
export const UPDATE_INSIGHT360_PERSONA_LABEL =
  'UPDATE_INSIGHT360_PERSONA_LABEL';
export const SAVE_ATTITUDINAL_TEMPLATE_DATA = 'SAVE_ATTITUDINAL_TEMPLATE_DATA';
export const SHOW_DEEP_DIVE_POPUP = 'SHOW_DEEP_DIVE_POPUP';
export const SHOW_BC_CONFIG_SCREEN = 'SHOW_BC_CONFIG_SCREEN';
export const NO_BC_STUDIES = 'NO_BC_STUDIES';

// QTS
export const QTS_GET_SURVEYGIZMO_LOGIN_URL = 'QTS_GET_SURVEYGIZMO_LOGIN_URL';
export const QTS_GET_SURVEY_LIST = 'QTS_GET_SURVEY_LIST';
export const QTS_PING_TEST = 'QTS_PING_TEST';
export const GET_QTS_REPORTS_DICTIONARY_TREE_LOAD =
  'GET_QTS_REPORTS_DICTIONARY_TREE_LOAD';
export const QTS_VIEW_TYPE = 'QTS_VIEW_TYPE';
export const QTS_SELECTED_STUDY = 'QTS_SELECTED_STUDY';
export const QTS_GET_SURVEY_QUESTIONS = 'QTS_GET_SURVEY_QUESTIONS';
export const QTS_GET_SURVEY_OPTIONS = 'QTS_GET_SURVEY_OPTIONS';
export const QTS_SURVEY_GIZMO_LOGGEDIN = 'QTS_SURVEY_GIZMO_LOGGEDIN';
export const QTS_NEW_SURVEY_NAME = 'QTS_NEW_SURVEY_NAME';
export const QTS_NEW_SURVEY_ID = 'QTS_NEW_SURVEY_ID';
export const QTS_NEW_PRODEGEPROJECT_ID = 'QTS_NEW_PRODEGEPROJECT_ID';
export const QTS_TARGETING_CRIETERIA = 'QTS_TARGETING_CRIETERIA';
export const GET_QTS_FEASIBILITY_RUN = 'GET_QTS_FEASIBILITY_RUN';
export const QTS_CREATE_SIMMONS_PROJECT = 'QTS_CREATE_SIMMONS_PROJECT';
export const QTS_CREATE_PRODIGY_PROJECT = 'QTS_CREATE_PRODIGY_PROJECT';
export const QTS_CREATE_PRODIGY_QUOTA = 'QTS_CREATE_PRODIGY_QUOTA';
export const QTS_GET_SURVEY = 'QTS_GET_SURVEY';
export const UPDATE_QTS_DICTIONARY_QO = 'UPDATE_QTS_DICTIONARY_QO';
export const UPDATE_QTS_SURVEY = 'UPDATE_QTS_SURVEY';
export const SAVE_QTS_GIZMO_QUESTION = 'SAVE_QTS_GIZMO_QUESTION';
export const QTS_CLEAR_SURVEY = 'QTS_CLEAR_SURVEY';
export const QTS_SURVEY_INFO_SAMPLE_EDITED = 'QTS_SURVEY_INFO_SAMPLE_EDITED';
export const QTS_SURVEY_SUBMIT_APPROVAL = 'QTS_SURVEY_SUBMIT_APPROVAL';
export const QTS_FETCH_IR = 'QTS_FETCH_IR';

export const QTS_EXPRESSION_LIST = 'QTS_EXPRESSION_LIST';
export const QTS_REMOVE_ROW_SELECTION = 'QTS_REMOVE_ROW_SELECTION';
export const QTS_EDIT_SURVEY = 'QTS_EDIT_SURVEY';
export const QTS_GET_DEFAULT_SAMPLE = 'QTS_GET_DEFAULT_SAMPLE';
export const QTS_RESET_PRODEGE_PROJECT = 'QTS_RESET_PRODEGE_PROJECT';
export const QTS_SET_TARGETING_CRITERIA = 'QTS_SET_TARGETING_CRITERIA';
export const QTS_SURVEY_DETAIL_HISTORY = 'QTS_SURVEY_DETAIL_HISTORY';

export const IE_MRI_STUDIES = 'IE_MRI_STUDIES';
export const QTS_PRODIGGY_MAPPING = 'QTS_PRODIGGY_MAPPING';
export const QTS_GET_SURVEY_SUCCESS = 'QTS_GET_SURVEY_SUCCESS';
export const RESET_SELECTED_KEYWORDS = 'RESET_SELECTED_KEYWORDS';

export const SET_360REPORTS_VARIABLE_SELECTION =
  'SET_360REPORTS_VARIABLE_SELECTION';
export const SET_360_STUDY = 'SET_360_STUDY';
export const ADD_ALL_SELECTED_KPI_INFO = 'ADD_ALL_SELECTED_KPI_INFO';

export const GEOGRAPHY_CATG_LIST = [
  {
    nodeId: 100000,
    parent: 0,
    name: 'U.S. Census Region',
    type: 'G',
    fname: null,
  },
  {
    nodeId: 200000,
    parent: 0,
    name: 'State',
    type: 'G',
    fname: null,
  },
  {
    nodeId: 300000,
    parent: 0,
    name: 'Market',
    type: 'G',
    fname: null,
  },
  {
    nodeId: 400000,
    parent: 0,
    name: 'County',
    type: 'G',
    fname: null,
  },
  {
    nodeId: 500000,
    parent: 0,
    name: 'Zip Codes',
    type: 'G',
    fname: null,
  },
];

export const GEOGRAPHY_BASES = [
  'INREGION',
  'INSTATE',
  'INMARKET',
  'INCOUNTY',
  'INZIP',
];
export const SAVE_360_SELECTED_FILTERS = 'SAVE_360_SELECTED_FILTERS';
export const ALL_MARKETS = { a: 'ALL MARKETS', i: '0', c: 'MARKET', p: null };
export const SET_BRAND_CATALYST_PREFERENCE_DATA =
  'SET_BRAND_CATALYST_PREFERENCE_DATA';

// salescatalyst
export const ADD_AUDIENCE_DATA_POINTS = 'ADD_AUDIENCE_DATA_POINTS';
export const SAVE_SALES_CATALYST_BASE_INFO = 'SAVE_SALES_CATALYST_BASE_INFO';
export const REMOVE_SALES_CATALYST_BASE_INFO =
  'REMOVE_SALES_CATALYST_BASE_INFO';
export const RESET_SALES_CATALYST = 'RESET_SALES_CATALYST';
export const RESET_SALES_CATALYST_SCREEN = 'RESET_SALES_CATALYST_SCREEN';
export const RUN_SALES_CATALYST = 'RUN_SALES_CATALYST';
export const SET_DATA_ON_SCREEN_VAL = 'SET_DATA_ON_SCREEN_VAL';
export const RESET_SALES_BRAND_SUMMARY = 'RESET_SALES_BRAND_SUMMARY';
export const RESET_SALES_PITCH_SUMMARY = 'RESET_SALES_PITCH_SUMMARY';
export const DELETE_INPUT_TABLE_ITEM = 'DELETE_INPUT_TABLE_ITEM';
export const UPDATE_SALES_CATALYST_SELECTION =
  'UPDATE_SALES_CATALYST_SELECTION';
export const DELETE_SALES_CATALYST_SELECTION =
  'DELETE_SALES_CATALYST_SELECTION';
export const UPDATE_DATA_ON_STUDY_CHANGE = 'UPDATE_DATA_ON_STUDY_CHANGE';
export const UPDATE_BRAND_SELECTION_DATA = 'UPDATE_BRAND_SELECTION_DATA';
export const UPDATE_PITCH_SELECTION_DATA = 'UPDATE_PITCH_SELECTION_DATA';
export const UPDATE_SELECTED_TEMPLATES_DATA = 'UPDATE_SELECTED_TEMPLATES_DATA';
export const CLEAR_SALES_BRANDS_SECTION_SEARCH_RESULT =
  'CLEAR_SALES_BRANDS_SECTION_SEARCH_RESULT';
export const GET_OVERLAP_SAMPLE_WEIGHTED_DATA =
  'GET_OVERLAP_SAMPLE_WEIGHTED_DATA';
export const RESET_OVERLAP_SAMPLE_WEIGHTED_DATA =
  'RESET_OVERLAP_SAMPLE_WEIGHTED_DATA';
export const RESET_MEDIA_PACKAGE_CATEGORY = 'RESET_MEDIA_PACKAGE_CATEGORY';
export const FETCH_BRAND = 'FETCH_BRAND';
export const FETCH_BRAND_CATEGORY = 'FETCH_BRAND_CATEGORY';
export const GET_BAR_CHART_REPORT = 'GET_BAR_CHART_REPORT';
export const RESET_BAR_CHART_REPORT = 'RESET_BAR_CHART_REPORT';
export const SET_CHART_SORT_INFO = 'SET_CHART_SORT_INFO';
export const SET_SC_CONFIG_PACKAGE_DATA = 'SET_SC_CONFIG_PACKAGE_DATA';
export const SHOW_SC_CONFIG_SCREEN = 'SHOW_SC_CONFIG_SCREEN';
export const SET_SC_COMPETITION_DATA = 'SET_SC_COMPETITION_DATA';
export const SET_SC_TARGET_FILTER_DATA = 'SET_SC_TARGET_FILTER_DATA';
export const UPDATE_SC_DATA_ON_SCREEN = 'UPDATE_SC_DATA_ON_SCREEN';

export const GET_CROSSTAB_SAMPLE_WEIGHTED_DATA =
  'GET_CROSSTAB_SAMPLE_WEIGHTED_DATA';
export const FETCH_SAMPLE_CROSSTAB_KPI = 'FETCH_SAMPLE_CROSSTAB_KPI';
export const CLEAR_SAMPLE_WEIGHTED_CROSSTAB_KPI =
  'CLEAR_SAMPLE_WEIGHTED_CROSSTAB_KPI';
export const GET_FUNCTION_LIST_FOR_PROBABILITIES =
  'GET_FUNCTION_LIST_FOR_PROBABILITIES';

export const FETCH_CROSSTAB_TRENDS_KPI = 'FETCH_CROSSTAB_TRENDS_KPI';

export const CLEAR_TREE_LOAD_NODE_LIST = 'CLEAR_TREE_LOAD_NODE_LIST';
export const CLEAR_TREE_NODE = 'CLEAR_TREE_NODE';
export const CLEAR_SAMPLE_WEIGHTED_QUICKREPORTS_KPI =
  'CLEAR_SAMPLE_WEIGHTED_QUICKREPORTS_KPI';
export const SALES_ATTITUDE_MARKET_DATA = 'SALES_ATTITUDE_MARKET_DATA';
export const SHOW_SALES_ATTITUDE_MARKET_DATA =
  'SHOW_SALES_ATTITUDE_MARKET_DATA';

export const SHOW_SALES_DEMO_MARKET_DATA = 'SHOW_SALES_DEMO_MARKET_DATA';

export const RESET_ATTITUDE_DEMO_SECTION_DATA =
  'RESET_ATTITUDE_DEMO_SECTION_DATA';
// export const TARGET_MARKET_OVERLAP_RAECH = 'TARGET_MARKET_OVERLAP_RAECH';
export const SET_MEDIA_PACKAGE_INPUT_FLAG = 'SET_MEDIA_PACKAGE_INPUT_FLAG';
export const SALES_PERSONA_HEADER_INFO = 'SALES_PERSONA_HEADER_INFO';

export const UPDATE_COMMON_STUDY = 'UPDATE_COMMON_STUDY';
export const UPDATE_CROSSTAB_TITLE_HEADER = 'UPDATE_CROSSTAB_TITLE_HEADER';
export const UPDATE_CROSSTAB_GRID_TITLE_HEADER =
  'UPDATE_CROSSTAB_GRID_TITLE_HEADER';
export const RESTORE_TITLE_NAME = 'RESTORE_TITLE_NAME';
export const FETCH_STANDARD_BASE_LIST = 'FETCH_STANDARD_BASE_LIST';

export const EXPORT_BASE_SELCTION_LIST = 'EXPORT_BASE_SELCTION_LIST';

export const UPDATE_DATA_ON_SCREEN = 'UPDATE_DATA_ON_SCREEN';
export const GET_ACTIVITIES_TEMPLATE_LIST = 'GET_ACTIVITIES_TEMPLATE_LIST';
export const SET_SALES_CATALYST_PREFERENCE_DATA =
  'SET_SALES_CATALYST_PREFERENCE_DATA ';
export const UPDATE_SALES_CATALYST_SESSION_STUDY =
  'UPDATE_SALES_CATALYST_SESSION_STUDY';

// admin
export const ADMIN_USERS = 'ADMIN_USERS';
export const ADMIN_USER_SEARCHING = 'ADMIN_USER_SEARCHING';
export const ADMIN_ACCOUNTS = 'ADMIN_ACCOUNTS';
export const CLEAR_ADMIN_ACCOUNTS_SEARCH = 'CLEAR_ALL_ADMIN_SEARCH';
export const CLEAR_ADMIN_ACCOUNTS_SEARCH_DATA =
  'CLEAR_ADMIN_ACCOUNTS_SEARCH_DATA';
export const ADMIN_ACCOUNTS_SEARCH_DATA = 'ADMIN_ACCOUNTS_SEARCH_DATA';
export const CLEAR_ADMIN_USERS_SEARCH = 'CLEAR_ADMIN_USERS_SEARCH';
export const TOGGLE_ACCOUNT_DETAILS = 'TOGGLE_ACCOUNT_DETAILS';
export const ACCOUNT_DETAILS_SUCCESS = 'ACCOUNT_DETAILS_SUCCESS';

// Preferences
export const GET_PREFERENCES = 'GET_PREFERENCES';
export const SET_PREFERENCES = 'SET_PREFERENCES';
export const CHANGE_LAST_LOCATION = 'CHANGE_LAST_LOCATION';
export const ADMIN_ADD_USER = 'ADMIN_ADD_USER';
export const SET_PREFERENCE_STUDY_FLAG = 'SET_PREFERENCE_STUDY_FLAG';

export const GET_LATEST_STUDIES = 'GET_LATEST_STUDIES';
export const AUTO_UPDATE_FLAG = 'AUTO_UPDATE_FLAG';
export const SHOW_MRI_INSIGHT360_PERSONAS_PROFILES =
  'SHOW_MRI_INSIGHT360_PERSONAS_PROFILES';

// Support
export const ACTIVE_SUPPORT_NAVIGATION = 'ACTIVE_SUPPORT_NAVIGATION';
export const TOGGLE_SUPPORT_NAVIGATION = 'TOGGLE_SUPPORT_NAVIGATION';
export const RESET_SUPPORT_NAVIGATION = 'RESET_SUPPORT_NAVIGATION';
export const PROFILE_ATTITUDES = 'PROFILE_ATTITUDES';
export const SET_SUPPORT_NAVIGATION = 'SET_SUPPORT_NAVIGATION';
export const SET_DOC_STUDIES = 'SET_DOC_STUDIES';

// Geomap
export const CLEAR_GEOMAP_REPORTS_SAMPLE_WEIGHTED =
  'CLEAR_GEOMAP_REPORTS_SAMPLE_WEIGHTED';
export const UPDATE_GEOMAP_REPORTS_SAMPLE_WEIGHTED =
  'UPDATE_GEOMAP_REPORTS_SAMPLE_WEIGHTED';
export const GET_GEOMAP_REPORTS_SAMPLE_WEIGHTED =
  'GET_GEOMAP_REPORTS_SAMPLE_WEIGHTED';
export const SELECT_GEOMAP_REPORT = 'SELECT_GEOMAP_REPORT';
export const GET_GEOMAPPING_STUDY = 'GET_GEOMAPPING_STUDY';
export const NO_GEOMAPPING_STUDIES = 'NO_GEOMAPPING_STUDIES';
export const SET_GEOMAP_BASE_TARGET = 'SET_GEOMAP_BASE_TARGET';
export const REMOVE_GEOMAP_KPI = 'REMOVE_GEOMAP_KPI';
export const UPDATE_PARENT_DRAGGED_NODES = 'UPDATE_PARENT_DRAGGED_NODES';
export const SET_PARENT_CHILD_COUNT_MAP = 'SET_PARENT_CHILD_COUNT_MAP';
export const SET_EXTRACTED_NODES = 'SET_EXTRACTED_NODES';
export const UPDATE_GEOMAP_SAMPLE_WEIGHTED = 'UPDATE_GEOMAP_SAMPLE_WEIGHTED';
export const SET_ORIGINAL_TITLE = 'SET_ORIGINAL_TITLE';
export const SET_GEOGRAPHIES_COUNT = 'SET_GEOGRAPHIES_COUNT';
export const UPDATE_GEO_MAP_SETTINGS = 'UPDATE_GEO_MAP_SETTINGS';
export const UPDATE_COMPLETE_GEO_MAP_SETTINGS =
  'UPDATE_COMPLETE_GEO_MAP_SETTINGS';
export const LOADING_GEO_MAP_TABLE_DATA = 'LOADING_GEO_MAP_TABLE_DATA';

// section sort based on reach on index
export const SET_SECTION_SORT_KEY = 'SET_SECTION_SORT_KEY';
// mme
export const GET_MME_SAMPLE_WEIGHTED_DATA = 'GET_MME_SAMPLE_WEIGHTED_DATA';
export const GET_MME_SAMPLE_WEIGHTED = 'GET_MME_SAMPLE_WEIGHTED';
export const UPDATE_MME_TITLE_HEADER = 'UPDATE_MME_TITLE_HEADER';
export const UPDATE_MME_SAMPLE_WEIGHTED = 'UPDATE_MME_SAMPLE_WEIGHTED';
export const UPDATE_MME_GRID = 'UPDATE_MME_GRID';
export const SET_SELECTED_MME_BASE = 'SET_SELECTED_MME_BASE';
export const CLEAR_MME_SAMPLE_WEIGHTED = 'CLEAR_MME_SAMPLE_WEIGHTED';
export const FETCH_MME_MEDIA_LIST = 'FETCH_MME_MEDIA_LIST';
export const FETCH_MME_STANDARD_BASE_LIST = 'FETCH_MME_STANDARD_BASE_LIST';
export const UPDATE_SELECTED_MEDIA_VEHICLE = 'UPDATE_SELECTED_MEDIA_VEHICLE';
export const ON_CHANGE_PROPERTY = 'ON_CHANGE_PROPERTY';
export const UPDATE_SELECTED_STATEMENT_VARIABLES =
  'UPDATE_SELECTED_STATEMENT_VARIABLES';
export const SHOW_MME_GRID = 'SHOW_MME_GRID';
export const UPDATE_REPORT_TYPE_VARIABLE = 'UPDATE_REPORT_TYPE_VARIABLE';
export const UPDATE_DIMENSION_TYPE_VARIABLE = 'UPDATE_DIMENSION_TYPE_VARIABLE';
export const ENABLE_MME_EDITOR_VIEW = 'ENABLE_MME_EDITOR_VIEW';
export const UPDATE_MME_TAB_GRID_DATA = 'UPDATE_MME_TAB_GRID_DATA';
export const EXPORT_MME = 'EXPORT_MME';
export const SHOW_MME_VALIDATED_DATA = 'SHOW_MME_VALIDATED_DATA';
export const UPDATE_PREVIOUS_LIST_SELECTION = 'UPDATE_PREVIOUS_LIST_SELECTION';
export const UPDATE_PREVIOUS_SELECTED_DATA = 'UPDATE_PREVIOUS_SELECTED_DATA';
export const RESET_MME_EDITOR_VIEW_TO_DEFAULT =
  'RESET_MME_EDITOR_VIEW_TO_DEFAULT';
export const CLEAR_MME_GRID_DATA = 'CLEAR_MME_GRID_DATA';
export const CLEAR_MME_TARGETS = 'CLEAR_MME_TARGETS';

// profile brands..
export const SHOW_INSIGHT360_PROFILE_PERSONAS_BRANDS =
  'SHOW_INSIGHT360_PROFILE_PERSONAS_BRANDS';
export const UPDATE_INSIGHT360_PROFILE_BRANDS =
  'UPDATE_INSIGHT360_PROFILE_BRANDS';
export const SHOW_INSIGHT360_PROFILE_MEDIA = 'SHOW_INSIGHT360_PROFILE_MEDIA';
export const UPDATE_INSIGHT360_PROFILE_MEDIA =
  'UPDATE_INSIGHT360_PROFILE_MEDIA';

// update target sample and weight
export const UPDATE_TARGET_SAMPLE_AND_WEIGHT =
  'UPDATE_TARGET_SAMPLE_AND_WEIGHT';
/* Weight Type */
export const UPDATE_WEIGHT_TYPES = 'UPDATE_WEIGHT_TYPES';
export const UPDATE_SELECTED_GEOGRAPHICS_TAB =
  'UPDATE_SELECTED_GEOGRAPHICS_TAB';
export const FETCH_GEOGRAPHICS_DATA = 'FETCH_GEOGRAPHICS_DATA';
export const UPDATE_COUNTY_AND_ZIPCODE_CATEGORY =
  'UPDATE_COUNTY_AND_ZIPCODE_CATEGORY';

// Omnibus
/* START - Turn-Key Omnibus */
export const SET_IE_ACTIVE_STEP = 'SET_IE_ACTIVE_STEP';
export const IE_STUDIES_REQUEST = 'IE_STUDIES_REQUEST';
export const IE_STUDIES_SUCCESS = 'IE_STUDIES_SUCCESS';
export const IE_STUDIES_FAILURE = 'IE_STUDIES_FAILURE';
export const IE_SURVEY_LIST_REQUEST = 'IE_SURVEY_LIST_REQUEST';
export const IE_SURVEY_LIST_SUCCESS = 'IE_SURVEY_LIST_SUCCESS';
export const IE_SURVEY_LIST_FAILURE = 'IE_SURVEY_LIST_FAILURE';
export const RESET_IE_STATE = 'RESET_IE_STATE';
export const RESET_IE_SURVEY_INFO = 'RESET_IE_SURVEY_INFO';
export const SET_IE_SURVEY_DETAILS = 'SET_IE_SURVEY_DETAILS';
export const SET_IE_SURVEY_NAME = 'SET_IE_SURVEY_NAME';

export const SET_IE_CATEGORIES_REQUEST = 'SET_IE_CATEGORIES_REQUEST';
export const SET_IE_CATEGORIES_SUCCESS = 'SET_IE_CATEGORIES_SUCCESS';
export const SET_IE_CATEGORIES_FAILURE = 'SET_IE_CATEGORIES_FAILURE';

export const SET_IE_SURVEY_CATEGORY = 'SET_IE_SURVEY_CATEGORY';
export const SET_IE_SURVEY_STUDY = 'SET_IE_SURVEY_STUDY';
export const SET_IE_SURVEY_INFO = 'SET_IE_SURVEY_INFO';

export const IE_PRODEGE_MAPPING_REQUEST = 'IE_PRODEGE_MAPPING_REQUEST';
export const IE_PRODEGE_MAPPING_SUCCESS = 'IE_PRODEGE_MAPPING_SUCCESS';
export const IE_PRODEGE_MAPPING_FAILURE = 'IE_PRODEGE_MAPPING_FAILURE';

export const IE_KEYWORDS_REQUEST = 'IE_KEYWORDS_REQUEST';
export const IE_KEYWORDS_SUCCESS = 'IE_KEYWORDS_SUCCESS';
export const IE_KEYWORDS_FAILURE = 'IE_KEYWORDS_FAILURE';

export const IE_TARGET_REQUEST = 'IE_TARGET_REQUEST';
export const IE_TARGET_SUCCESS = 'IE_TARGET_SUCCESS';
export const IE_TARGET_FAILURE = 'IE_TARGET_FAILURE';

export const SET_IE_SELECTED_TARGETS = 'SET_IE_SELECTED_TARGETS';

export const IE_EDIT_SURVEY = 'IE_EDIT_SURVEY';
export const IE_EDIT_SURVEY_REQUEST = 'IE_EDIT_SURVEY_REQUEST';
export const IE_EDIT_SURVEY_SUCCESS = 'IE_EDIT_SURVEY_SUCCESS';
export const IE_EDIT_SURVEY_FAILURE = 'IE_EDIT_SURVEY_FAILURE';
export const SET_IE_SAMPLE_WGTD = 'SET_IE_SAMPLE_WGTD';
export const SET_IE_CROSSTAB = 'SET_IE_CROSSTAB';
export const SET_IE_COMPLETES = 'SET_IE_COMPLETES';
export const GET_IE_IR_SS_REQUEST = 'GET_IE_IR_SS_REQUEST';
export const GET_IE_IR_SS_FAILURE = 'GET_IE_IR_SS_FAILURE';
export const GET_IE_IR_SS_SUCCESS = 'GET_IE_IR_SS_SUCCESS';

export const IE_CREATE_SURVEY_REQUEST = 'IE_CREATE_SURVEY_REQUEST';
export const IE_CREATE_SURVEY_SUCCESS = 'IE_CREATE_SURVEY_SUCCESS';
export const IE_CREATE_SURVEY_FAILURE = 'IE_CREATE_SURVEY_FAILURE';

export const SET_IE_SURVEY_DICTIONARY = 'SET_IE_SURVEY_DICTIONARY';
export const SET_IE_SURVEY_DICTIONARY_ERROR = 'SET_IE_SURVEY_DICTIONARY_ERROR';
export const SET_IE_SURVEY_DICTIONARY_TEXT = 'SET_IE_SURVEY_DICTIONARY_TEXT';

export const IE_SURVEY_METADATA_REQUEST = 'IE_SURVEY_METADATA_REQUEST';
export const IE_SURVEY_METADATA_SUCCESS = 'IE_SURVEY_METADATA_SUCCESS';
export const IE_SURVEY_METADATA_QO = 'IE_SURVEY_METADATA_QO';
export const IE_SURVEY_METADATA_FAILURE = 'IE_SURVEY_METADATA_FAILURE';

/* END: - Turn-Key Omnibus */

export const SET_GEOGRAPHICS_TABLE_DATA = 'SET_GEOGRAPHICS_TABLE_DATA';
export const DELETE_GEOGRAPHIES_TABLE_DATA = 'DELETE_GEOGRAPHIES_TABLE_DATA';
export const FETCH_GEOGRAPHICS_TABLE_API_QUEUES =
  'FETCH_GEOGRAPHICS_TABLE_API_QUEUES';
export const RESET_GEOGRAPHICS_TAB_API_QUEUES =
  'RESET_GEOGRAPHICS_TAB_API_QUEUES';
export const RESET_GEOGRAPHICS_TABLE_DATA_APIS_API_QUEUES =
  'RESET_GEOGRAPHICS_TABLE_DATA_APIS_API_QUEUES';
export const CLEAR_SELECTED_WEIGHT_QUICK_REPORT =
  'CLEAR_SELECTED_WEIGHT_QUICK_REPORT';

export const TOGGLE_CROSSTAB_GRID_DATA = 'TOGGLE_CROSSTAB_GRID_DATA';
export const UPDATE_GEOMAP_SORT_DATA = 'UPDATE_GEOMAP_SORT_DATA';
export const UPDATE_GEOMAP_TARGET_AND_BASE_ON_STUDY_CHANGE =
  'UPDATE_GEOMAP_TARGET_AND_BASE_ON_STUDY_CHANGE';

export const EXPRESSIONS_BREADCRUMBS_LIST = 'EXPRESSIONS_BREADCRUMBS_LIST';
export const RESET_GEOGRAPHICS_TABLE_DATA_WITH_ZEROES =
  'RESET_GEOGRAPHICS_TABLE_DATA_WITH_ZEROES';

export const SET_EXP_API_QUEUE = 'SET_EXP_API_QUEUE';
export const RESET_EXP_API_QUEUE = 'RESET_EXP_API_QUEUE';
export const FETCH_GEOMAPPING_SMART_SEARCH_KPI =
  'FETCH_GEOMAPPING_SMART_SEARCH_KPI';
export const SET_GEOGRAPHICS_TABLE_API_CALL_STATUS =
  'SET_GEOGRAPHICS_TABLE_API_CALL_STATUS';
// cluster & correspondence
export const CREATE_CAC_NEW_PROJECT = 'CREATE_CAC_NEW_PROJECT';
export const ADD_CAC_PROJECT_DETAILS = 'ADD_CAC_PROJECT_DETAILS';
export const CAC_HANDLE_VIEW_SWITCH = 'CAC_HANDLE_VIEW_SWITCH';
export const SET_CAC_PROJECT_TO_ACTIVE = 'SET_CAC_PROJECT_TO_ACTIVE';
export const TOGGLE_COLLAPSIBLE_DROPDOWN = 'TOGGLE_COLLAPSIBLE_DROPDOWN';
export const CAC_SHOW_CONTRIBUITON_SCORES = 'CAC_SHOW_CONTRIBUITON_SCORES';
export const CAC_SET_IS_CENTER_CHART = 'CAC_SET_ISCENTERCHART';
export const CAC_SET_SHOW_PASSIVES = 'CAC_SET_SHOWPASSIVES';
export const CAC_SET_IS_AXIS_VISIBLE = 'CAC_SET_IS_AXIS_VISIBLE';
export const CAC_SET_ARE_ROWS_VISIBLE = 'CAC_SET_ARE_ROWS_VISIBLE';
export const CAC_SET_ARE_COLS_VISIBLE = 'CAC_SET_ARE_COLS_VISIBLE';
export const CAC_SHOW_ROW_LONG_NAMES = 'CAC_SHOW_ROW_LONG_NAMES';
export const CAC_SHOW_COL_LONG_NAMES = 'CAC_SHOW_COL_LONG_NAMES';
export const CAC_SHOW_PASSIVE_LONG_NAMES = 'CAC_SHOW_PASSIVE_LONG_NAMES';
export const CAC_NODE_LABEL_POSITIONS = 'CAC_NODE_LABEL_POSITIONS';
export const CAC_CLEAR_LABEL_POSITIONS = 'CAC_CLEAR_LABEL_POSITIONS';
export const CAC_CHART_VIEW = 'CAC_CHART_VIEW';
export const CAC_UPDATE_NODES = 'CAC_UPDATE_NODES';
export const CAC_NODE_COLORS = 'CAC_NODE_COLORS';
export const CAC_IS_PROJECT_SAVED = 'CAC_IS_PROJECT_SAVED';
export const ADD_TO_PASSIVE = 'ADD_TO_PASSIVE';
export const EDIT_PROJECT_TAB_NAME = 'EDIT_PROJECT_TAB_NAME';
export const SHOW_CAC_SAVED_PROJECTS = 'SHOW_CAC_SAVED_PROJECTS';
export const UPDATE_NEW_PROJECT_PID = 'UPDATE_NEW_PROJECT_PID';
export const UPDATE_TEMP_PROJECT_TITLE = 'UPDATE_TEMP_PROJECT_TITLE';
export const CREATE_CAC_NEW_PROJECT_FROM_SAVE =
  'CREATE_CAC_NEW_PROJECT_FROM_SAVE';
export const REMOVE_ACTIVE_PROJECT_TEMP_TITLE =
  'REMOVE_ACTIVE_PROJECT_TEMP_TITLE';
export const ADD_OPENED_PROJECTS_DATA = 'ADD_OPENED_PROJECTS_DATA';
export const SET_EXPORT_SPINNER_FLAG = 'SET_EXPORT_SPINNER_FLAG';
export const EXPORT_PROGRESS_WARNING_MSG_FLAG =
  'EXPORT_PROGRESS_WARNING_MSG_FLAG';
export const DUPLICATE_PROJECT = 'DUPLICATE_PROJECT';
export const CAC_UPDATE_PROJECT_STUDY = 'CAC_UPDATE_PROJECT_STUDY';
export const CAC_UPDATE_PROJECT_WEIGHT_TYPES =
  'CAC_UPDATE_PROJECT_WEIGHT_TYPES';
export const CAC_EDIT_ROW_COL_TITLE = 'CAC_EDIT_ROW_COL_TITLE';
export const CAC_RESTORE_ROW_COL_TITLE = 'CAC_RESTORE_ROW_COL_TITLE';
export const CAC_ADD_PROJECT_CONTOUR_MAP = 'CAC_ADD_PROJECT_CONTOUR_MAP';

// DE - Data Enablement
export const RESET_DE_STATE = 'RESET_DE_STATE';
// export const SET_DE_ACTIVE_NAV = 'SET_DE_ACTIVE_NAV';
export const GET_DE_DEFINITION_REQUEST = 'GET_DE_DEFINITION_REQUEST';
export const GET_DE_DEFINITION_FAILURE = 'GET_DE_DEFINITION_FAILURE';
export const GET_DE_DEFINITION_SUCCESS = 'GET_DE_DEFINITION_SUCCESS';
export const SET_DE_CT_TABLE_QUERY = 'SET_DE_CT_TABLE_QUERY';
export const RESET_QUERY_ON_SEARCH_SORT = 'RESET_QUERY_ON_SEARCH_SORT';
export const RESET_TARGET_LIST = 'RESET_TARGET_LIST';

export const RESET_DE_STUDY_DEF_STATE = 'RESET_DE_STUDY_DEF_STATE';
export const GET_DE_STUDY_DEF_REQUEST = 'GET_DE_STUDY_DEF_REQUEST';
export const GET_DE_STUDY_DEF_FAILURE = 'GET_DE_STUDY_DEF_FAILURE';
export const GET_DE_STUDY_DEF_SUCCESS = 'GET_DE_STUDY_DEF_SUCCESS';

export const GET_DEFINITION_EXP_REQUEST = 'GET_DEFINITION_EXP_REQUEST';
export const SET_DEFINITION_EXP_RESPONSE = 'SET_DEFINITION_EXP_RESPONSE';
export const SET_DEFINITION_SAMPLE_WEIGHTED = 'SET_DEFINITION_SAMPLE_WEIGHTED';
export const DE_RESET_IMPORT_SELECTION = 'DE_RESET_IMPORT_SELECTION';
export const DE_SET_DEFINITION_FOR_IMPORT = 'DE_SET_DEFINITION_FOR_IMPORT';
export const DE_SAVE_TARGETS = 'DE_SAVE_TARGETS';
export const DE_EDIT_TARGETS = 'DE_EDIT_TARGETS';
export const GET_DE_STUDY_REQUEST = 'GET_DE_STUDY_REQUEST';
export const GET_DE_STUDY_FAILURE = 'GET_DE_STUDY_FAILURE';
export const GET_DE_STUDY_SUCCESS = 'GET_DE_STUDY_SUCCESS';
export const SET_DE_LATEST_STUDY_FLAG = 'SET_DE_LATEST_STUDY_FLAG';
export const SET_DE_ACTIVE_STUDY_WEIGHT = 'SET_DE_ACTIVE_STUDY_WEIGHT';
export const SET_DE_ACTIVE_STUDY = 'SET_DE_ACTIVE_STUDY';
export const DE_IS_EDIT_TARGET_DEFINITION = 'DE_IS_EDIT_TARGET_DEFINITION';
export const DE_IS_IMPORT_TARGET_DEFINITION = 'DE_IS_IMPORT_TARGET_DEFINITION';
export const SET_DE_AUTOCODE_TEMP_TARGET_EDIT =
  'SET_DE_AUTOCODE_TEMP_TARGET_EDIT';

export const GET_DE_DESTINATION_REQUEST = 'GET_DE_DESTINATION_REQUEST';
export const ADD_DE_AUTOCODE_TARGETS = 'ADD_DE_AUTOCODE_TARGETS';
export const SAVE_DE_AUTOCODE_TARGET = 'SAVE_DE_AUTOCODE_TARGET';
export const REMOVE_DE_AUTOCODE_TARGETS = 'REMOVE_DE_AUTOCODE_TARGETS';
export const SET_ADD_TARGET_API_FLAG = 'SET_ADD_TARGET_API_FLAG';
export const REMOVE_DE_AUTOCODE_TARGET_ROW = 'REMOVE_DE_AUTOCODE_TARGET_ROW';
export const RESET_SAVED_COUNT = 'RESET_SAVED_COUNT';
export const DE_SET_SELECTED_LABEL_AC = 'DE_SET_SELECTED_LABEL_AC';
export const GET_DE_DESTINATION_FAILURE = 'GET_DE_DESTINATION_FAILURE';
export const GET_DE_DESTINATION_SUCCESS = 'GET_DE_DESTINATION_SUCCESS';
export const SET_CAMPAIGN_DETAILS = 'SET_CAMPAIGN_DETAILS';
export const SET_CAMPAIGN_DETAILS_TEMP = 'SET_CAMPAIGN_DETAILS_TEMP';
export const SET_DE_DIST_REQUEST_NAME = 'SET_DE_REQUEST_NAME';
export const SET_DE_DIST_FOR_ACTIVATION = 'SET_DE_FOR_ACTIVATION';
export const SET_DE_DIST_FROM_TO_DATE = 'SET_DE_DIST_FROM_TO_DATE';
export const SET_DE_DIST_ADD_TO_QUEUE_ERR = 'SET_DE_DIST_ADD_TO_QUEUE_ERR';
export const DE_DIST_ADD_TO_QUEUE_NAME_ERR = 'DE_DIST_ADD_TO_QUEUE_NAME_ERR';
export const DE_DIST_ADD_TO_QUEUE_TARGET_ERR =
  'DE_DIST_ADD_TO_QUEUE_TARGET_ERR';
export const DE_DIST_ADD_TO_QUEUE_DATE_ERR = 'DE_DIST_ADD_TO_QUEUE_DATE_ERR';
export const DE_DIST_ADD_TO_QUEUE_NAME_ERR_RESET =
  'DE_DIST_ADD_TO_QUEUE_NAME_ERR_RESET';
export const DE_DIST_ADD_TO_QUEUE_TARGET_ERR_RESET =
  'DE_DIST_ADD_TO_QUEUE_TARGET_ERR_RESET';
export const DE_DIST_ADD_TO_QUEUE_DATE_ERR_RESET =
  'DE_DIST_ADD_TO_QUEUE_DATE_ERR_RESET';
export const SET_DE_DIST_DELETE_REQUEST = 'SET_DE_DIST_DELETE_REQUEST';
export const SET_DE_DELETE_CAMPAIGN_SUCCESS = 'SET_DE_DELETE_CAMPAIGN_SUCCESS';
export const GET_DE_CAMPAIGNLIST_REQUEST = 'GET_DE_CAMPAIGNLIST_REQUEST';
export const GET_DE_CAMPAIGNLIST_FAILURE = 'GET_DE_CAMPAIGNLIST_FAILURE';
export const GET_DE_CAMPAIGNLIST_SUCCESS = 'GET_DE_CAMPAIGNLIST_SUCCESS';
export const GET_DE_CAMPAIGNLIST_UPDATED = 'GET_DE_CAMPAIGNLIST_UPDATED';
export const SET_TARGET_DISTRIBUTE = 'SET_TARGET_DISTRIBUTE';
export const SET_TARGET_DISTRIBUTE_TEMP = 'SET_TARGET_DISTRIBUTE_TEMP';
export const RESET_DE_DISTRIBUTE = 'RESET_DE_DISTRIBUTE';
export const RESET_DE_LABEL = 'RESET_DE_LABEL';
export const ASK_DE_REQUEST_CHANGES = 'ASK_DE_REQUEST_CHANGES';
export const SET_DISTRIBUTE_MODAL = 'SET_DISTRIBUTE_MODAL';
export const SET_DE_DIST_REQUEST_ID = 'SET_DE_DIST_REQUEST_ID';
export const SET_DE_DIST_REQUEST_STATUS = 'SET_DE_DIST_REQUEST_STATUS';
export const SET_DESTINATION_DETAILS = 'SET_DESTINATION_DETAILS';
export const RESET_DE_DISTRIBUTE_ERRORS = 'RESET_DE_DISTRIBUTE_ERRORS';
export const SET_DE_DISTREQUEST_STATUS = 'SET_DE_DISTREQUEST_STATUS';
export const SET_DE_DIST_CONFIRM_REQUEST = 'SET_DE_DIST_CONFIRM_REQUEST';

// Target Label Actions
export const SET_TARGET_LABEL = 'SET_TARGET_LABEL';
export const RESET_TARGET_LABEL = 'RESET_TARGET_LABEL';
export const SET_TARGET_LABEL_EXPRESSION = 'SET_TARGET_LABEL_EXPRESSION';
export const DE_EXPORT_TARGET = 'DE_EXPORT_TARGET';

// cluster & correspondence
export const CAC_CLOSE_PROJECT = 'CAC_CLOSE_PROJECT';
export const SHOW_HIDE_DATAPOINT = 'SHOW_HIDE_DATAPOINT';
export const CAC_CORR_SWITCH_DATA = 'CAC_CORR_SWITCH_DATA';
export const CAC_HANDLE_TAB_SELECT = 'CAC_HANDLE_TAB_SELECT';
export const CAC_CLUST_UPDATE_SEGMENT_COUNT = 'CAC_CLUST_UPDATE_SEGMENT_COUNT';
export const CAC_CLUST_SELECTED_CLUSTER = 'CAC_CLUST_SELECTED_CLUSTER';
export const CORR_TABLE_TAB_SELECT = 'CORR_TABLE_TAB_SELECT';
export const CORR_TABLE_SORT_DATA = 'CORR_TABLE_SORT_DATA';
export const CAC_CLUSTER_SWITCH_DATA = 'CAC_CLUSTER_SWITCH_DATA';

// Crosstab
export const CLEAR_OPEN_CROSSTAB_ARR = 'CLEAR_OPEN_CROSSTAB_ARR';
export const OPEN_SHARED_CROSSTAB = 'OPEN_SHARED_CROSSTAB';
export const EXPRESSIONS_DETAILS_LIST = 'EXPRESSIONS_DETAILS_LIST';

// autocode
export const GET_CAC_AUTOCODE_SAMPLE_WEIGHTED =
  'GET_CAC_AUTOCODE_SAMPLE_WEIGHTED';
export const GET_CAC_AUTOCODE_SAMPLE_WEIGHTED_DATA =
  'GET_CAC_AUTOCODE_SAMPLE_WEIGHTED_DATA';

export const FUNCTION_SAMPLE_WEIGHTED = 'FUNCTION_SAMPLE_WEIGHTED';
export const CLEAR_DICTIONARY_SAMPLE_WEIGHTED =
  'CLEAR_DICTIONARY_SAMPLE_WEIGHTED';
export const CLEAR_CAC_SAMPLE_WEIGHTED = 'CLEAR_CAC_SAMPLE_WEIGHTED';
export const UPDATE_CAC_SAMPLE_WEIGHTED = 'UPDATE_CAC_SAMPLE_WEIGHTED';
export const CLUSTER_PROJECT_DETAILS = 'CLUSTER_PROJECT_DETAILS';
export const CAC_ADD_DEFAULT_BASE = 'CAC_ADD_DEFAULT_BASE';
export const HANDLE_CLUSTER_BY_SWITCH = 'HANDLE_CLUSTER_BY_SWITCH';
export const SET_CONTRACT_ADMIN_NAVIGATION = 'SET_CONTRACT_ADMIN_NAVIGATION';
export const EDIT_CLUSTER_SEGMENT_NAME = 'EDIT_CLUSTER_SEGMENT_NAME';
export const EXPORT_CLUSTER_AND_CORRESPONDENCE =
  'EXPORT_CLUSTER_AND_CORRESPONDENCE';

// contract Admin
export const GET_CONTRACT_ADMIN_DEFINITION_SUCCESS =
  'GET_CONTRACT_ADMIN_DEFINITION_SUCCESS';
export const GET_CONTRACT_ADMIN_DEFINITION_FAILURE =
  'GET_CONTRACT_ADMIN_DEFINITION_FAILURE';
export const SET_CA_TABLE_QUERY = 'SET_CA_TABLE_QUERY';
export const RESET_CA_QUERY_ON_SEARCH_SORT = 'RESET_CA_QUERY_ON_SEARCH_SORT';
export const GET_CA_DEFINITION_REQUEST = 'GET_CA_DEFINITION_REQUEST';
export const FETCH_MIDDLE_DATA_SUCCESS = 'FETCH_MIDDLE_DATA_SUCCESS';
export const FETCH_STUDY_DATA = 'FETCH_STUDY_DATA';
export const FETCH_SELECTED_LOCATION = 'FETCH_SELECTED_LOCATION';
export const GET_ACCOUNTS_LOCATIONS = 'GET_ACCOUNTS_LOCATIONS';
export const FETCH_PROP_CODES = 'FETCH_PROP_CODES';

export const GET_FOOTNOTES = 'GET_FOOTNOTES';
export const SET_ADD_NEW_FLAG = 'SET_ADD_NEW_FLAG';
export const SET_ADD_NEW_ENTITLEMENT_FLAG = 'SET_ADD_NEW_ENTITLEMENT_FLAG';
export const CA_SUMMARY = 'CA_SUMMARY';
export const SET_EDIT_ENTITLEMENT_FLAG = 'SET_EDIT_ENTITLEMENT_FLAG';
export const SET_ENTITLEMENT_ID = 'SET_ENTITLEMENT_ID';
export const SET_CONTRACT_EDIT_DATA = 'SET_CONTRACT_EDIT_DATA';
export const SET_SELECTED_LOCATION_ID = 'SET_SELECTED_LOCATION_ID';
export const RESET_ADD_ACCOUNT_FORM = 'RESET_ADD_ACCOUNT_FORM';
export const SET_SELECTED_CONTRACT_ID = 'SET_SELECTED_CONTRACT_ID';
export const SET_UNSAVED_CHANGE_FLAG = 'SET_UNSAVED_CHANGE_FLAG';
export const SET_EDITED_FORM_DATA = 'SET_EDITED_FORM_DATA';
export const SET_EDITED_ACCOUNT_DATA = 'SET_EDITED_ACCOUNT_DATA';
export const SET_MRI_TOP_MARKETS = 'SET_MRI_TOP_MARKETS';
export const SET_MEMRI_USERS = 'SET_MEMRI_USERS';
export const SET_SIMMONS_LOCAL_MARKETS = 'SET_SIMMONS_LOCAL_MARKETS';
export const SET_EDIT_ENT_NAME = 'SET_EDIT_ENT_NAME';
export const SET_EDIT_ENT_MARKETS = 'SET_EDIT_ENT_MARKETS';
export const SET_EDIT_ENT_MEMRI = 'SET_EDIT_ENT_MEMRI';
export const SET_PROP_CODE_TYPES = 'SET_PROP_CODE_TYPES';
export const SET_EDIT_PROP_CODE = 'SET_EDIT_PROP_CODE';
export const SET_EDIT_MEMRI_USER = 'SET_EDIT_MEMRI_USER';
export const SET_EDIT_MRI_MARKET = 'SET_EDIT_MRI_MARKET';
export const SET_REQUEST = 'SET_REQUEST';

export const DE_BUILD_UPDATE_EXPRESSION_NAME =
  'DE_BUILD_UPDATE_EXPRESSION_NAME';
export const DE_BUILD_UPDATE_UNSAVED_CHANGES =
  'DE_BUILD_UPDATE_UNSAVED_CHANGES';
export const SET_ENT_UNSAVED_CHANGES_FLAG = 'SET_ENT_UNSAVED_CHANGES_FLAG';
export const DE_BUILD_UPDATE_ERROR_SELECTION_BOX =
  'DE_BUILD_UPDATE_ERROR_SELECTION_BOX';
export const DE_BUILD_SET_IS_EDIT_TARGET = 'DE_BUILD_SET_IS_EDIT_TARGET';
export const SET_DE_BUILD_EDIT_TARGET = 'SET_DE_BUILD_EDIT_TARGET';
export const DE_SET_ORIGINAL_TARGET_NAME = 'DE_SET_ORIGINAL_TARGET_NAME';
export const DE_SET_IMPORT_VALIDATIONS = 'DE_SET_IMPORT_VALIDATIONS';
export const DE_BUILD_SET_IS_SAVE_TARGET_CLICKED =
  'DE_BUILD_SET_IS_SAVE_TARGET_CLICKED';
export const DE_BUILD_DUPLICATE_TARGET = 'DE_BUILD_DUPLICATE_TARGET';

// RLD Tool Action types
export const RLD_TOOL_SET_ACCOUNTS = 'RLD_TOOL_SET_ACCOUNTS';
export const RLD_TOOL_SET_SELECTED_ACCOUNT = 'RLD_TOOL_SET_SELECTED_ACCOUNT';
export const RLD_TOOL_SET_STUDY_DATA = 'RLD_TOOL_SET_STUDY_DATA';
export const RLD_TOOL_SET_SELECTED_STUDY = 'RLD_TOOL_SET_SELECTED_STUDY';
export const RLD_TOOL_GET_DICTIONARY_TREE_LOAD =
  'RLD_TOOL_GET_DICTIONARY_TREE_LOAD';
export const RLD_TOOL_UPDATE_DICTIONARY_TREE_LOAD =
  'RLD_TOOL_UPDATE_DICTIONARY_TREE_LOAD';
export const RLD_TOOL_SET_DICTIONARY_TARGET_TREE =
  'RLD_TOOL_SET_DICTIONARY_TARGET_TREE';
export const RLD_TOOL_CLEAR_TREE_LOAD_NODE_LIST =
  'RLD_TOOL_CLEAR_TREE_LOAD_NODE_LIST';
export const RLD_TOOL_SET_EXPORT_FILE_FORMAT =
  'RLD_TOOL_SET_EXPORT_FILE_FORMAT';
export const RLD_TOOL_SET_DICTIONARY_FILE_STRUCTURE =
  'RLD_TOOL_SET_DICTIONARY_FILE_STRUCTURE';
export const RLD_TOOL_SET_EMAIL = 'RLD_TOOL_SET_EMAIL';
export const RLD_TOOL_SUCCESS_MESSAGE = 'RLD_TOOL_SUCCESS_MESSAGE';
export const UPDATE_RLD_MODULE_STUDY = 'UPDATE_RLD_MODULE_STUDY';
export const RLD_TOOL_RESET_GENERATE_FILE = 'RLD_TOOL_RESET_GENERATE_FILE';
export const SET_QUICK_REPORT_FLAG = 'SET_QUICK_REPORT_FLAG';
export const RLD_TOOL_SET_IS_DICTIONARY_ONLY =
  'RLD_TOOL_SET_IS_DICTIONARY_ONLY';
export const RLD_TOOL_SET_IS_ALL_LOCAL_MARKETS =
  'RLD_TOOL_SET_IS_ALL_LOCAL_MARKETS';
export const RLD_TOOL_SET_FILE_STRUCTURE_FORMAT =
  'RLD_TOOL_SET_FILE_STRUCTURE_FORMAT';
export const RLD_TOOL_SET_CURRENT_VIEW = 'RLD_TOOL_SET_CURRENT_VIEW';
export const RLD_TOOL_SET_RLD_LIST_DATA = 'RLD_TOOL_SET_RLD_LIST_DATA';
